<template>
    <v-dialog v-model="dialog" persistent width="450px">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>
                    Content Sections Preview
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <v-container>
                <v-select outlined :items="previewTypes" v-model="selectedType">
                </v-select>
                <div style="height:600px;overflow-y:scroll">
                    <allAtOnce v-if="selectedType==1" />
                    <oneAtATime v-if="selectedType==2" :setSelected="setSelected" />
                </div>
            </v-container>

        </v-card>
    </v-dialog>

</template>

<script>
    import oneAtATime from "../components/one-at-a-time"
    import allAtOnce from "../components/all-at-once"
    export default {
        components: {
            oneAtATime,
            allAtOnce
        },
        data() {
            return {
                previewTypes: [{
                    text: "All at once",
                    value: 1
                }, {
                    text: "One at a time",
                    value: 2
                }],
                selectedType: 1,
                dialog: false,
                workflow_controller: this.get_controller("workflow"),
                content_controller: this.get_controller("content_section")
            };
        },
        mounted() {},
        methods: {
            show() {
                let self = this
                self.dialog = true
            },
            setSelected(item) {
                let self = this
                self.content_controller.selectedContent = item
            },

            back() {
                let self = this;
                self.$router.back();
            },
        },
    };
</script>